var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root-contrast" },
    [
      _c("route-name", { attrs: { propsRouteName: "法律风险审核" } }),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "choose-doc" },
          [
            _c("p", [_vm._v("1.选择合同领域")]),
            _c("p", { staticStyle: { margin: "10px 0" } }, [
              _vm._v("根据提示信息完善表格内容，请勿缺少信息")
            ]),
            _c(
              "el-form",
              {
                ref: "typeForm",
                attrs: { model: _vm.form, inline: "", size: "small" }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "合同领域:",
                      prop: "fieId",
                      rules: {
                        required: true,
                        message: "请选择合同领域",
                        trigger: "blur"
                      }
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "请选择合同领域" },
                        on: { change: _vm.typeChange },
                        model: {
                          value: _vm.form.fieId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fieId", $$v)
                          },
                          expression: "form.fieId"
                        }
                      },
                      _vm._l(_vm.examineTypes, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "合同规则:",
                      prop: "ruleId",
                      rules: {
                        required: true,
                        message: "请选择审核规则",
                        trigger: "blur"
                      }
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择审核规则" },
                        on: { change: _vm.rulesChange },
                        model: {
                          value: _vm.form.ruleId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ruleId", $$v)
                          },
                          expression: "form.ruleId"
                        }
                      },
                      _vm._l(_vm.examRules, function(item) {
                        return _c("el-option", {
                          key: Object.values(item)[0],
                          attrs: {
                            label: Object.keys(item)[0],
                            value: Object.values(item)[0]
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "examine" }, [
          _c("div", { staticClass: "upload-box" }, [
            _c("p", { staticStyle: { color: "#222" } }, [_vm._v("上传合同：")]),
            _c(
              "div",
              { staticClass: "upload" },
              [
                _c("img", {
                  attrs: {
                    src: "/images/AISmart/icon/group.png",
                    width: "49px",
                    height: "47px",
                    alt: ""
                  }
                }),
                _c(
                  "el-upload",
                  {
                    ref: "exUpload",
                    staticClass: "upload-bth",
                    attrs: {
                      action: "#",
                      limit: 1,
                      "auto-upload": false,
                      "on-exceed": _vm.exceed,
                      accept: ".doc,.docx",
                      "on-change": _vm.changeTarget,
                      "before-upload": _vm.fileUpBefore
                    }
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "danger", plain: "" } },
                      [_vm._v("选择文件")]
                    )
                  ],
                  1
                ),
                _c(
                  "span",
                  { staticStyle: { color: "#999", "margin-top": "10px" } },
                  [
                    _vm._v(
                      "可支持 .doc、.docx 格式文件，上传单个文件大小不超过30M。"
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger", loading: _vm.loading },
                  on: { click: _vm.extract }
                },
                [_vm._v("提交审核")]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cbe2a52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cbe2a52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/smartDoc/docExamine/examine.vue
// module id = /Skg
// module chunks = 177